import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import FullScreenOverlay from '@bibliocommons/deprecated-base-full-screen-overlay';
import { bibShape, userIdentityShape, ugcPrivateNoteShape } from '@bibliocommons/bc-prop-types';

import { ExpandableText } from 'app/components/shared/Expandable';
import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import PrivateNoteUGCEditor from '../UGCEditors/PrivateNoteUGCEditor';
import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';
import DisplayHeading from '../DisplayHeading';

import './PrivateNoteDisplay.scss';

export default class PrivateNoteDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <PrivateNoteUGCEditor
          bib={this.props.bib}
          shelfItem={this.props.shelfItem}
          handleClose={this.closeEditor}
          existingPrivateNote={this.props.privateNote}
          privateNotesTransactions={this.props.privateNotesTransactions}
          shelfTransactions={this.props.shelfTransactions}
          privateNotesActions={this.props.privateNotesActions}
          shelfActions={this.props.shelfActions}
        />
      )
    );
  }

  renderActions() {
    const { privateNotesActions, privateNotesTransactions, owner, privateNote, bib } = this.props;

    if (owner.get('loggedIn')) {
      const noteId = privateNote.get('id');
      const metadataId = privateNote.get('metadataId');
      const handleRemove = () => privateNotesActions.removePrivateNote({ metadataId, noteId });
      const isRemoving = privateNotesTransactions.getIn([metadataId, noteId, 'isRemoving'], false);
      const title = bib.getIn(['briefInfo', 'title']);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_private_note" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_private_note" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={this.openEditor}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage}
        />
      );
    }

    return null;
  }

  render() {
    const { privateNote, truncateCount } = this.props;
    if (privateNote) {
      return (
        <DisplayWrapper className="cp-ugc-private-note-display">
          <DisplayHeading>
            <FormattedMessage id="ugc_private_note_display_label" />
          </DisplayHeading>
          <ExpandableText text={privateNote.get('note')} truncateCount={truncateCount} />
          {this.renderActions()}

          <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
            {this.renderEditor()}
          </FullScreenOverlay>
        </DisplayWrapper>
      );
    }
    return null;
  }
}

PrivateNoteDisplay.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  privateNote: ugcPrivateNoteShape,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  truncateCount: PropTypes.number
};
